<script>
  import AddAudioForm from "./AddAudioForm.svelte";
  import OneAudio from "./OneAudio.svelte";

  import { onMount } from 'svelte';

	onMount(() => {
//		console.log('app has mounted. v2024-05-07_16:25:51');
	});
//  console.log("App.svelte");
</script>



<main>
  <AddAudioForm  />
</main>
